let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("66TdV")).then(() => parcelRequire('aDR56'));